import React, { useContext, useEffect, useState } from "react";
import "../styles/ThankYouPage.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { getSettings } from "../services/settings";
import { getOrder } from "../services/orders";
import { trackCustomEvent } from "../services/facebookPixel";
import { GlobalContext } from "../contexts/GlobalContext";
import { Helmet } from "react-helmet-async";
import { formatDate } from "../Components/Helpers/Helper";

const ThankYouPage = () => {
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState(null);

  const { allSettings } = useContext(GlobalContext);
  const { id } = useParams();
  // const [{ allSettings }, setState] = useState({
  //   allSettings: [],
  // });
  const location = useLocation();
  const isStripe = location.state?.isStripe;
  const transactionId = location.state?.transactionId;
  const paymentSuccess = location.state?.paymentSuccess;
  const amountPaid = location.state?.amountPaid;
  const error = location.state?.error;
  useEffect(() => {
    if (!isStripe) {
      const storedResponse = localStorage.getItem("paymentResponse");
      sessionStorage.setItem("paymentResponse", storedResponse);

      if (storedResponse) {
        setPaymentResponse(JSON.parse(storedResponse));
        // localStorage.removeItem("paymentResponse");
      }
      // Clean up localStorage on page unload
      const handleUnload = () => {
        localStorage.removeItem("paymentResponse");
      };

      window.addEventListener("unload", handleUnload);

      return () => {
        window.removeEventListener("unload", handleUnload);
      };
    }
  }, [isStripe]);

  let paymentSuccessful;
  if ((isStripe && paymentSuccess) || paymentResponse?.responseCode === "0") {
    paymentSuccessful = true;
  } else {
    paymentSuccessful = false;
  }
  useEffect(() => {
    const fetchOrder = async () => {
      setLoading(true);
      try {
        const data = await getOrder(id);
        setOrder(data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    };
    fetchOrder();
  }, [id]);
  const email = allSettings.find((setting) => setting.name === "email")?.value;
  const phone = allSettings.find((setting) => setting.name === "phone")?.value;
  useEffect(() => {
    if (paymentResponse && order) {
      if (paymentSuccessful) {
        // Payment was successful
        trackCustomEvent("PaymentCompleted", {
          content_name: "Payment Completed",
          value: order?.amount_paid || amountPaid || 0, // Send the amount paid
          currency: "GBP",
          status: "Success",
          transaction_id: transactionId || paymentResponse?.transactionUnique,
        });
      } else {
        // Payment failed
        trackCustomEvent("PaymentCompleted", {
          content_name: "Payment Failed",
          value: order?.amount_paid || 0, // Send the amount attempted
          currency: "GBP",
          status: "Failed",
        });
      }
    }
  }, [paymentResponse, order]);
  // }, [paymentResponse, paymentSuccessful, order]);
  return !loading ? (
    <div
      className="d-flex justify-content-center align-items-center mt-5 "
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "100%",
      }}
    >
      {" "}
      <Helmet>
        {" "}
        <title>Thank You For Placing Order | Pass Swiftly</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div></div>
      <p className="h5 font-semibold fs-3 fst-italic">
        Your Order Has Been Placed, Thank You{" "}
      </p>
      <p className="fs-3">Payment Info</p>
      <p className="fs-5">
        Status:{" "}
        {paymentResponse?.responseCode === "0" ||
        order?.amount_paid > 0 ||
        paymentSuccessful
          ? "Completed"
          : "Declined"}
      </p>
      {paymentResponse?.responseCode === "0" && (
        <p className="fs-5">
          Transaction ID: {paymentResponse?.transactionUnique}
        </p>
      )}
      {isStripe && error && <p className="fs-5">Error: {error}</p>}
      {isStripe && transactionId && (
        <p className="fs-5">Transaction ID: {transactionId}</p>
      )}
      <div
        className="order-confirm-card order-confirm-container col-md-3"
        style={{ maxWidth: "100%" }}
      >
        <div className="d-flex align-items-center justify-content-center mb-4">
          <p className="h5 font-semibold  color-quaternary">Order Details</p>
        </div>
        <div className="order-confirm-section">
          <div className="order-confirm-section mt-4">
            <div className="d-flex justify-content-between fs-5">
              <span>Order Number</span>
              <span className="text">{order?.id}</span>
            </div>
            <hr />
          </div>
          {order?.order_detail?.course && (
            <div className="d-flex justify-content-between mt-3 fs-5">
              <span>{order?.order_detail?.course?.hours} Hours Course</span>
              <span className="">£{order?.order_detail?.course?.price}</span>
            </div>
          )}
          {order?.lessons &&
            order?.lessons.map((lesson, index) => (
              <div>
                <div
                  key={index}
                  className="d-flex justify-content-between mt-3 fs-5
              "
                >
                  <span>Lesson Duration</span>
                  <span className="">{lesson?.duration / 60} Hours</span>
                </div>
                {/* <hr />
                <div
                  key={index}
                  className="d-flex justify-content-between mt-3 fs-5
              "
                >
                  <span>Lesson Date</span>
                  <span className="">{formatDate(lesson?.date)}</span>
                </div>
                <hr />
                <div
                  key={index}
                  className="d-flex justify-content-between mt-3 fs-5
              "
                >
                  <span>Lesson Time</span>
                  <span className="">{lesson?.start_time}</span>
                </div> */}
                <hr />
              </div>
            ))}
        </div>
        <div className="order-confirm-section mt-4">
          <div className="d-flex justify-content-between fs-5">
            <span>Total Amount</span>
            <span className="">£{order?.total}</span>
          </div>
          <hr />
        </div>
        <div className="order-confirm-section mt-4">
          <div className="d-flex justify-content-between fs-5">
            <span>Amount Recieved</span>
            <span className="">
              £
              {order?.amount_paid && order?.amount_paid > 0
                ? order?.amount_paid || 0
                : isStripe && paymentSuccessful
                ? amountPaid || 0
                : 0}
            </span>
          </div>
        </div>
        <div className="order-confirm-section mt-4">
          <hr />
          <div className="d-flex justify-content-between fs-5  color-quaternary">
            <span>Balance </span>
            <span className="font-weight-bold">
              £
              {isStripe && paymentSuccess
                ? order?.total - amountPaid
                : order?.balance
                ? order?.balance
                : order?.total}
            </span>
          </div>
          <br />
          {paymentSuccessful === false && order?.amount_paid <= 0 && (
            <div className="bg-warning p-3">
              <span className="text-danger fs-6">
                Payment attempt failed. Please contact on email{" "}
                <span
                  onClick={() => (window.location = `mailto:${email}`)}
                  className="text-black cursor-pointer"
                >
                  {email}
                </span>{" "}
                or directly call on{" "}
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => (window.location = `tel:${phone}`)}
                  className="text-black"
                >
                  {phone}
                </span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default ThankYouPage;
